import { render, staticRenderFns } from "./emoji_token.vue.js?vue&type=template&id=0d8021d4&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./emoji_token.vue?vue&type=template&id=0d8021d4&vue3"
import script from "./emoji_token.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./emoji_token.vue?vue&type=script&lang=js&vue3"
export * from "./emoji_token.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./emoji_token.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports